/* eslint-disable */
import ApplicationApi from "../api/ApplicationApi";
import ApplicationStore from "./AppStore";

class RootStore {
    applicationStore:ApplicationStore;
    constructor(applicationApi: ApplicationApi) {
        this.applicationStore = new ApplicationStore(applicationApi);
    }
}

export default RootStore